import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import AuthService from "@/services/AuthService";
import router from "@/router";
import i18n from "@/i18n/index";
import { HOME_PATH } from "@/config/AppConfig";

const token: string = AuthService.getToken();
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_BASE_URL;

axios.interceptors.request.use((config: AxiosRequestConfig) => {
  if (i18n.locale && config?.headers) {
    config.headers["Accept-Language"] =
      String(i18n.locale).toLowerCase() +
      "-" +
      String(i18n.locale).toUpperCase();
  }

  return config;
});

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  function (error: any) {
    if (error.response.status === 503) {
      return router.push({ name: "MaintenanceMode" });
    }
    // if (
    //   error.response &&
    //   401 === error.response.status &&
    //   "/login" !== window.location.pathname
    // ) {
    //   const authService: AuthService = new AuthService();
    //   AuthService.clear();
    //   window.location.href = "/login";
    // }

    // Access denied error
    // if (
    //   error.response &&
    //   403 === error.response.status &&
    //   ![HOME_PATH, "/welcome"].includes(window.location.pathname)
    // ) {
    //   window.location.href = HOME_PATH;
    // }

    return Promise.reject(error);
  }
);
